
const TYPES = ({
  // load state with localstorage
  loadStateWithLocalStorage: 'LOAD_STATE_USER_LOGGED',
});

export default TYPES;
